// extracted by mini-css-extract-plugin
export default {"container":"AddDetailOther_container__BrvLz","desciption":"AddDetailOther_desciption__ZZ-Xc","delete_button":"AddDetailOther_delete_button__ENsyA"};